<template>
<div class="cart-main-wrapper pt-20 pb-20 pt-sm-20 pb-sm-20">
  <div v-if="cart.length > 0">
    <div class="container">
       <div class="row">
            <div class="cart-table table-responsive">
              <table class="table table-bordered">
                <thead>
              <tr>
                <th class="pro-title">Product</th>
                <th class="pro-price">Price</th>
              </tr>
              </thead>
              <tbody>
                  <template v-for="product in cart">
                      <tr>
                        <td class="pro-title">{{product.Title}}</td>
                        <td class="pro-price"><span>&euro;{{product.Price}}</span></td>
                      </tr>
                  </template>
              </tbody>
              </table>
            </div>
           </div>
            <div class="row">&nbsp;</div>
        </div> 
    <div>
  </div>

  </div>

</div>
</template>

<script>

  export default {
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    components: {
    },
    methods: {
      checkOut () {
        this.$router.push('/CustAppoint');
      },
      navigate (item) {
        console.log ("nav to :" + item);
        this.$router.push(item);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cart/CartCheckout.vue